import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    ordenTrabajoId: 0,
    ordenSubtrabajo: {},
    ordenSubtrabajoLogistica: {},

    id: 0,
    articuloTipoId: 0,
    articuloTipo: null,
    rubroTrabajoId: 0,
    rubroTrabajo: null,
    cantidad: 0,
    monedaId: 0,
    moneda: null,
    monedaAbreviacion: null,
    proveedorId: 0,
    proveedor: null,
    costo: 0,
    costoTotal: 0,
    costoUnitario: false,
    diasProduccion: 0,
    logistica: false,
    costoRemitos: false,
    observaciones: '',
    rowVersion: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDEN' (state, params) {
        state.ordenTrabajoId = params.ordenTrabajoId;
        state.ordenSubtrabajo = {};

        state.articuloTipoId = 0;
        state.articuloTipo = '';
        state.rubroTrabajoId = 0;
        state.rubroTrabajo = '';
        state.cantidad = 0;
        // state.monedaId = 0;
        // state.moneda = null;
        // state.monedaAbreviacion = null;
        state.monedaId = 101;
        state.moneda = 'PESOS';
        state.monedaAbreviacion = '$';
        state.proveedorId = 0;
        state.proveedor = '';
        state.costo = 0;
        state.costoTotal = 0;
        state.costoUnitario = false;
        state.diasProduccion = 0;
        state.logistica = false;
        state.costoRemitos = false;
        state.observaciones = '';
        state.rowVersion = null;

        if (params.logistica) {
            state.logistica = (/true/i).test(params.logistica);    
        }
    },
    'SET_ORDEN' (state, ordenSubtrabajo) {
        state.ordenSubtrabajo = ordenSubtrabajo;

        state.articuloTipoId = ordenSubtrabajo.articuloTipoId;
        state.articuloTipo = ordenSubtrabajo.articuloTipo;
        state.rubroTrabajoId = ordenSubtrabajo.rubroTrabajoId;
        state.rubroTrabajo = ordenSubtrabajo.rubroTrabajo;
        state.cantidad = parseInt(ordenSubtrabajo.cantidad);
        state.monedaId = ordenSubtrabajo.monedaId;
        state.moneda = ordenSubtrabajo.moneda.trim();
        state.monedaAbreviacion = ordenSubtrabajo.monedaAbreviacion.trim();
        state.proveedorId = ordenSubtrabajo.proveedorId;
        state.proveedor = ordenSubtrabajo.proveedor;
        state.costo = parseFloat(ordenSubtrabajo.costo);
        state.costoTotal = parseFloat(ordenSubtrabajo.costoTotal);
        state.costoUnitario = ordenSubtrabajo.costoUnitario;
        state.diasProduccion = parseInt(ordenSubtrabajo.diasProduccion);
        state.logistica = (/true/i).test(ordenSubtrabajo.logistica);
        state.costoRemitos = (/true/i).test(ordenSubtrabajo.costoRemitos);
        state.observaciones = ordenSubtrabajo.observaciones;
        state.rowVersion = ordenSubtrabajo.rowVersion;
    },
    'SET_ORDEN_SUBTRABAJO'(state, ordenSubtrabajo) {
        state.ordenSubtrabajo = ordenSubtrabajo;
    },
    'SET_ORDEN_SUBTRABAJO_LOGISTICA'(state, ordenSubtrabajo) {
        state.ordenSubtrabajoLogistica = ordenSubtrabajo;
    },
    'SET_ARTICULO_TIPO'(state, articuloTipo) {
        state.articuloTipoId = articuloTipo? articuloTipo.id : 0;
        state.articuloTipo = articuloTipo? articuloTipo.nombre.trim() : null;
        state.rubroTrabajoId = articuloTipo? articuloTipo.rubroTrabajo.id : 0;
        state.rubroTrabajo = articuloTipo? articuloTipo.rubroTrabajo.trim() : null;
        state.proveedorId = 0;
        state.proveedor = '';
        state.observaciones = articuloTipo? articuloTipo.descripcion.trim() : '';
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedorId= proveedor? proveedor.id : 0;
        state.proveedor= proveedor? proveedor.nombre.trim() : null;
    },
    'SET_MONEDA'(state, moneda) {
        if (moneda) {
            state.monedaId= moneda.id? moneda.id : 0;
            state.moneda= moneda.nombre? moneda.nombre.trim() : null;
            state.monedaAbreviacion = moneda.abreviacion? moneda.abreviacion.trim() : null;
        } else {
            state.monedaId= 0;
            state.moneda= null;
            state.monedaAbreviacion = null;
        }
    },
    'CALCULAR_COSTO_UNITARIO'(state) {
        if (state.cantidad != 0) {
            state.costo = roundToTwo(state.costoTotal / state.cantidad);
        } else {
            state.costo = 0;
        }
    },
    'CALCULAR_COSTO_TOTAL'(state) {
        state.costoTotal = roundToTwo(state.costo * state.cantidad);
    },
};

function roundToTwo(num) {    
    return +(Math.round(num + "e+2")  + "e-2");
}

const getters = {
    getField,

    ordenSubtrabajo (state) {
        return state.ordenSubtrabajo;
    },
    ordenSubtrabajoLogistica (state) {
        return state.ordenSubtrabajoLogistica;
    },
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDEN', params);

            if (params.ordenSubtrabajo) {
                commit('SET_ORDEN', params.ordenSubtrabajo);
                resolve();
            } else {
                resolve();
            }
        })            
    },
    save ( { state, commit }, params ) {
        return new Promise((resolve, reject) => {
            let costo = parseFloat(state.costo);
            let costoTotal = parseFloat(state.costoTotal);
            let costoUnitario = (/true/i).test(state.costoUnitario);

            if ((/true/i).test(state.costoUnitario)) {
                costoTotal = helpers.methods.roundToTwo(parseFloat(state.cantidad) * costo);
            } else {
                if (parseFloat(state.cantidad) == 0) {
                    costo = 0;
                } else {
                    costo = helpers.methods.roundToTwo(costoTotal / parseFloat(state.cantidad));
                }
            }

            if ((/true/i).test(state.costoRemitos)) {
                costo = 0;
                costoTotal = 0;
                costoUnitario = false;
            }

            let item = {
                articuloTipoId: state.articuloTipoId, 
                articuloTipo: state.articuloTipo,
                rubroTrabajoId: state.rubroTrabajoId,
                rubroTrabajo: state.rubroTrabajo,
                cantidad: parseInt(state.cantidad),
                monedaId: state.monedaId,
                moneda: state.moneda,
                monedaAbreviacion: state.monedaAbreviacion,
                proveedorId: state.proveedorId, 
                proveedor: state.proveedor,
                costo,
                costoTotal,
                costoUnitario,
                diasProduccion: parseInt(state.diasProduccion),
                logistica: (/true/i).test(state.logistica),
                costoRemitos: (/true/i).test(state.costoRemitos),
                observaciones: state.observaciones.trim(),
                rowVersion: state.rowVersion
            }
            
            let save = true;

            if (params) {
                if ((/true/i).test(params.produccion)) {
                    save = false;
                    commit('SET_ORDEN_SUBTRABAJO', item);
                    resolve();
                }
            }

            if (save) {
                let subtrabajo = {
                    articuloTipoId: state.articuloTipoId, 
                    rubroTrabajoId: state.rubroTrabajoId,
                    cantidad: parseInt(state.cantidad),
                    monedaId: state.monedaId,
                    proveedorId: state.proveedorId, 
                    costo,
                    costoTotal,
                    costoUnitario,
                    diasProduccion: parseInt(state.diasProduccion),
                    logistica: (/true/i).test(state.logistica),
                    costoRemitos: (/true/i).test(state.costoRemitos),
                    observaciones: state.observaciones.trim()
                }
    
                apiAxios.post('ordenestrabajos/' + state.ordenTrabajoId + '/add-subtrabajo', subtrabajo)
                    .then(res => {
                        commit('SET_ORDEN_SUBTRABAJO_LOGISTICA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)))                    
            }
        })
    },

    setProveedor: ( { commit }, proveedor) => {
        return new Promise((resolve, reject) => {
            commit('SET_PROVEEDOR', proveedor);
            resolve();
        })
    },
    setArticuloTipo: ( { commit }, articuloTipoId) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('articulostipos/' + articuloTipoId ) 
            .then(res => {
                commit('SET_ARTICULO_TIPO', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setMoneda: ( { commit }, moneda) => {
        return new Promise((resolve, reject) => {
            commit('SET_MONEDA', moneda);
            resolve();
        })
    },
    calcularCostoUnitario: ( {commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_UNITARIO');
            resolve();
        })
    },
    calcularCostoTotal: ( { commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_TOTAL');
            resolve();
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}